import React, { useState, useContext } from 'react';

import { CustomizeContext } from '../contexts/customize';

import cautionImg from '../../assets/caution.png';

const MtmConfirm = ({onClickConfirm}) => {
  const [popup, setPopup] = useState(false);
  const [error, setError] = useState([]);
  const { customizes } = useContext(CustomizeContext);

  const mtmBodyType = document.getElementById('mtm-customize').dataset.mtmBodyType;

  const clickConfirm = () => {
    let confirmCheck = true;
    let errorItem = [];
    for (let item in customizes) {
      if (item == 'sizes') {
        for (let size in customizes[item]) {
          if (size !== 'cuffs_width_left' && size !== 'cuffs_width_right' && size !== 'waist_size' && size !== 'yoke_size' && size !== 'sleeve_width') {
            if (customizes[item][size].id == '') {
              confirmCheck = false;
              errorItem.push(item + '-' + size);
            }
          }
        }
      } else if (item == 'embroideryOptions'){
        let emb_index = 0;
        let emb_value = false;
        let emb_text_length = 0;
        for (let embroidery in customizes[item]) {
          if (emb_index == 0 && customizes[item][embroidery].value == true && emb_value == false) {
            emb_value = true;
          } else if (emb_index == 0 && customizes[item][embroidery].value == undefined) {
            confirmCheck = false;
            errorItem.push(item);
          } else if (emb_index != 0 && emb_value == true && customizes[item][embroidery].value == '') {
            confirmCheck = false;
            errorItem.push(item + '-' + embroidery);
          } else if (emb_value == true && emb_index == 4) {
            let emb_text_4 = customizes[item][embroidery].value.split('.').join('');
            emb_text_length = emb_text_4.length;
          } else if (emb_value == true && emb_index == 5) {
            let emb_text_5 = customizes[item][embroidery].value.split('.').join('');
            if (emb_text_5.length != emb_text_length) {
              confirmCheck = false;
              errorItem.push(item);
            }
          }
          emb_index++;
        }
      } else if (item == 'brand_name' || item == 'kamakura_name') {
        continue;
      } else if (item == 'pocket' && mtmBodyType == 'formal'){
        continue;
      } else {
        if (customizes[item].id == '') {
          confirmCheck = false;
          errorItem.push(item);
        }
      }
    }

    if (confirmCheck) {
      // チェック完了
      document.getElementById('mtm-customize').classList.add('confirm');
      document.getElementById('mtm-timeline').classList.add('none');
      document.getElementById('mtm-header').classList.add('none');
      document.getElementById('onClickConfirm').click();
    } else {
      // エラー
      setPopup(true);
      setError(errorItem);
    }
  }

  const closePopup = () => {
    setPopup(false);
  }

  return (
    <>
      <div className="mtm-item__wrapper mtm-confirm" id="mtm-confirm">
        <p> Once you've change your selections, some selections may reset.</p>
        <div className="selects-item__detail_button">
          <button className="mtm-confirm_btn" onClick={clickConfirm}>Confirm</button>
          <button id="onClickConfirm" hidden onClick={onClickConfirm}></button>
        </div>
      </div>
      {popup && (
        <div className="confirmError popup_error">
          <div className="popup_error_bg" onClick={closePopup}></div>
          <div className="popup_error_content">
            <div className="popup_error_close" onClick={closePopup}></div>
            <div className="popup_error_heading">
              <img src={cautionImg} />
              <p>Caution</p>
            </div>
            <div className="popup_error_text">
              <p>
              Some fields have not been filled in. Please check and fill in the fields.
              </p>
              <ul>
              {error.map((item) => (
                <li>{item}</li>
              ))}
              </ul>
            </div>
            <div className="popup_error_button">
              <button onClick={closePopup}>Back To Customize</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default MtmConfirm;
